import { Suspense } from 'react';
import { Flex, Spinner, StackScreen, useScreenSize } from '@banhala/ui-kit';
import { SideMenu } from './components/SideMenu';
import { CategoryContent } from './components/CategoryContent';
import { useOverviewCategories } from './queries/useOverviewCategories';
import { useScrollSync } from './hooks/useScrollSync';
import { useLogViewOverview } from './hooks/useLogViewOverview';
import { CartIcon, SearchIcon } from 'shared/src/component';
import { bridge } from 'shared/src/utils';

const CategoryScreenContent = () => {
  const { data } = useOverviewCategories();
  const categories = data.item_list;

  const {
    activeIndex,
    contentRef,
    sideMenuRef,
    handleSectionLayout,
    handleContentScroll,
    handleMenuPress,
  } = useScrollSync();

  const { width: screenWidth } = useScreenSize();

  return (
    <Flex.Row flex={1} width={screenWidth}>
      <Flex flex={1}>
        <SideMenu
          categories={categories}
          activeIndex={activeIndex}
          scrollViewRef={sideMenuRef}
          onMenuPress={handleMenuPress}
        />
      </Flex>
      <Flex flex={2.27}>
        <CategoryContent
          categories={categories}
          contentRef={contentRef}
          onScroll={handleContentScroll}
          onSectionLayout={handleSectionLayout}
        />
      </Flex>
    </Flex.Row>
  );
};

export const CategoryScreen = () => {
  useLogViewOverview();

  return (
    <StackScreen
      title={'카테고리'}
      hideBackButton={true}
      rightIcons={[
        <SearchIcon screen={'OVERVIEW'} />,
        <CartIcon
          onPressCart={() => {
            bridge.logAnalyticsEvent({
              name: 'CLICK_CART',
              analytics: {
                SCREEN: 'OVERVIEW',
                LANDING_FROM: 'CARTICON',
              },
            });
          }}
        />,
      ]}
    >
      <Suspense
        fallback={
          <Flex.Center flex={1}>
            <Spinner />
          </Flex.Center>
        }
      >
        <Flex flex={1} alignItems={'center'}>
          <CategoryScreenContent />
        </Flex>
      </Suspense>
    </StackScreen>
  );
};
